import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { apiURL } from '../../utilities/URLs'
import { account } from '../../classes/Account'
import { setStoredSessionId } from '../../utilities/tracking/sessionStorage'

import ertcLogo from '../../assets/ertcLogo.png'

export default function Callback({ setShowNavBar }) {
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const email = encodeURIComponent(searchParams.get('email'))
  const code = searchParams.get('code')
  const redirect = searchParams.get('redirect')

  const [error, setError] = useState('')

  useEffect(() => {
    const handleSignIn = async () => {
      const verifyResponse = await fetch(`${apiURL}/api/login/verify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          code
        }),
        credentials: 'include'
      })
      const verifyData = await verifyResponse.json()
      if(verifyData.response.error) {
        console.error(verifyData.response.error)
        setError(verifyData.response.error)
      } else {
        account.setAccount(verifyData.response.account)
        account.accessToken = verifyData.response.accessToken
        localStorage.setItem('portalAccessToken', verifyData.response.accessToken)
        if (verifyData.response.sessionId)
          setStoredSessionId(verifyData.response.sessionId)
        setShowNavBar(true)
        navigate(redirect ? redirect : '/dashboard')
      }
    }

    handleSignIn()
  }, [])

  return (
    <div className='w-screen h-screen flex flex-col items-center justify-center p-6'>
      <div className='w-full flex flex-col items-center max-w-sm p-6 bg-gray-200 shadow-md rounded-md'>
        <img src={ertcLogo} alt='ERTC Logo' className='w-48 mb-6' />
        {!error ? (
          <div className='flex flex-row items-center justify-center gap-2 mt-5'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] border-gray-200 dark:border-slate-700 border-t-ertc-primary dark:border-t-ertc-primary h-8 w-8 animate-spin'></div>
            <p className='text-md text-center'>Signing In...</p>
          </div>
        ) : (
          <p className='text-red'>{error}</p>
        )}
      </div>
    </div>
  )
}